// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = () => ({
  container: {
    width: '100%',
  },
  priceContainer: {
    margin: '10px 0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  contentContainer: {
    margin: '10px 0',
  },
  circle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 10px',
    borderRadius: 20,
    backgroundColor: GlobalStyles.color.COLOR_GREEN
  },
  // Matches the issue-voucher screen: the amount is the figure the shop reads
  // back to the customer, so it carries more weight than its label.
  barcodeContainer: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'center',
  },
  barcodeImage: {
    maxWidth: '100%',
    height: 'auto',
  },
  priceText: {
    margin: 0,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // Lets a value that will not fit beside its label drop to the next line
    // whole, the way the app shows it, instead of being sawn in half
    // mid-address.
    flexWrap: 'wrap',
  },
  descText: {
    margin: 0,
    flex: 1,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  text: {
    margin: 0,
    // 'flex: 2' forced the value into two thirds of the row whatever its
    // length, which is what split "…@celad / onsoft.com" across two lines.
    // Growing from its own width instead, it sits beside the label when it
    // fits and takes a line of its own when it does not.
    flex: '1 1 auto',
    textAlign: 'right',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    // Only as a last resort - when even a full line cannot hold it. An email
    // is one unbreakable word to the browser, so without this an extreme
    // address would overflow the panel instead of wrapping.
    wordBreak: 'normal',
    overflowWrap: 'anywhere',
  }
});

export default styles;
